import React, { useState } from "react";
import {
  ColorIcon,
  colors,
  VStack,
  NextLink,
  responsive,
  Button,
  kakaoPixel,
  daangnPixelTrack,
  customEvent,
  tossPixel,
  pixelCustomEvent,
  PixelEventName,
  tiktokPixelTrack,
} from "goi_common";
import { BaseStack } from "goi_common/src/design-system";

import ReferioReviewSection from "./compnents/ReferioReviewSection";
import Footer from "@/containers/HomeV2/compnents/Footer";

import { Box } from "@chakra-ui/react";

import NewHeroSection from "@/containers/HomeV2/compnents/NewHeroSection";
import NewBenefitSection from "@/containers/HomeV2/compnents/NewBenefitSection";
import LandingFixedTwinButton from "@/components/common/LandingFixedTwinButton";
import useIntersectionObserver from "goi_common/src/hooks/useIntersectionObserver";
import CompareSection from "@/containers/HomeV2/compnents/CompareSection";
import FAQSection from "@/containers/HomeV2/compnents/FAQSection";
import { keyframes } from "@emotion/react";
import useLandingPageScroll from "@/hooks/useLandingPageScroll";
import useFunnelRouteDeclare from "@/hooks/useFunnelRouteDeclare";
import { landingFunnelKey } from "@/constants/funnelRouteDeclareValues";
import { appendFnk } from "@/utils/appendFnk";

import { naverConversionEvent } from "@/utils/naverPageView";
import { PRODUCT_GROUP } from "@/constants/productKey";
import useLandingPageEffect from "@/hooks/useLandingPage";

import { sessionStorage, storageKeys } from "@/utils/storage";
import { getVariationOnDemand } from "goi_common/src/utils/hackle";
import ReferioServiceSection from "./compnents/ReferioServiceSection";

const TRUST_INTRO_BASE_PATH = `/registration/trust-intro/?productGroup=${PRODUCT_GROUP["100"]}`;

const bounceAnimation = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

interface ReferioHomeContainerProps {
  additionalQueryParams?: string;
  funnelKey?: string;
  topBanner?: React.ReactNode;
}

export default function ReferioHomeContainer(
  props: ReferioHomeContainerProps = {}
) {
  const { additionalQueryParams, funnelKey } = props;

  const funnelKeyValue = funnelKey || landingFunnelKey.GROUP["100"];

  const { paths } = useFunnelRouteDeclare({
    uniqueKey: funnelKeyValue,
  });

  useLandingPageEffect();

  const { isHeroSectionVisible, heroSectionScrollTriggerRef } =
    useLandingPageScroll({
      verificationHref: `${paths.verification}`,
    });

  const [isArrowVisible, setIsArrowVisible] = useState(true);

  useIntersectionObserver({
    root: null,
    target: heroSectionScrollTriggerRef,
    onIntersect: () => {
      setIsArrowVisible(false);
    },
    onNotIntersect: () => {},
    threshold: 0.1,
  });

  const targetPath =
    paths["product-intro"] ||
    `/registration/product-intro/?productGroup=${PRODUCT_GROUP["100"]}`;

  const pathWithFnk = appendFnk(targetPath, funnelKeyValue);

  const finalPath = additionalQueryParams
    ? `${pathWithFnk}&${additionalQueryParams}`
    : pathWithFnk;

  const trustIntroPathWithFnk = appendFnk(
    TRUST_INTRO_BASE_PATH,
    funnelKeyValue
  );
  const trustIntroFinalPath = additionalQueryParams
    ? `${trustIntroPathWithFnk}&${additionalQueryParams}`
    : trustIntroPathWithFnk;

  const isAdsDiscountCampaign =
    sessionStorage.get(storageKeys.AdsDiscountCampaign) === "true";
  const isTmCampaign =
    sessionStorage.get(storageKeys.AdsDiscountCampaignIsTm) === "true";

  const ctaPath =
    isAdsDiscountCampaign && !isTmCampaign ? trustIntroFinalPath : finalPath;

  const exp304Dest =
    getVariationOnDemand(304) === "B" ? trustIntroFinalPath : ctaPath;

  return (
    <VStack css={{ color: colors.white, overflowX: "hidden" }}>
      <NewHeroSection
        hasCTA={false}
        padding={{ base: "48px 0 0", md: "52px 0 0" }}
      />
      <VStack background="#FFEACC" alignItems="center" padding="0px 0 52px">
        <BaseStack direction="horizontal" spacing={8}>
          <NextLink href={exp304Dest}>
            <Button
              className="body_16_m md_head_24_m"
              onClick={() => {
                customEvent({
                  newGtm: { path: "home", trigger_and_target: "CTA" },
                });
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "hero_CTA-uv_registration",
                  },
                });
                naverConversionEvent({ type: "view_product" });
                naverConversionEvent({ type: "lead" });
                kakaoPixel()?.participation();
                tossPixel()?.productView();
                daangnPixelTrack("ViewContent");
                tiktokPixelTrack("ViewContent");
                pixelCustomEvent(PixelEventName.ViewContent);
              }}
              css={responsive({
                border: `1px solid ${colors.orange650}`,
                borderRadius: "8px",
                background: colors.orange650,
                color: colors.white,
                padding: { base: "12px 31px", md: "16px 46px" },
                marginTop: { base: "16px", md: "20px" },
              })}
            >
              3분만에 간편가입
            </Button>
          </NextLink>
        </BaseStack>
      </VStack>

      <NewBenefitSection />

      <div ref={heroSectionScrollTriggerRef}></div>

      <ReferioServiceSection />

      {/* <AboutSection /> */}
      <CompareSection />

      <ReferioReviewSection />
      {/* <NumberOneSection />
      <CollaborationSection />
      <PRSection /> */}
      <FAQSection />

      <Footer />
      {!isHeroSectionVisible && (
        <LandingFixedTwinButton
          text="100원 상조로 장례 준비하기"
          href={exp304Dest}
          onCtaClick={() => naverConversionEvent({ type: "lead" })}
        />
      )}

      {isArrowVisible && (
        <Box
          position="fixed"
          bottom="20px"
          right="0px"
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="0px"
          justifyContent="center"
          width="100%"
          zIndex={1000}
          animation={`${bounceAnimation} 1.25s infinite`}
        >
          <VStack>
            <ColorIcon
              name="arrow_right_small"
              css={{
                transform: "translateY(0px) translateX(20px)",
                rotate: "90deg",
              }}
              size={34}
              color={colors.warmGray650}
            />
            <ColorIcon
              name="arrow_right_small"
              css={{ transform: "translateY(0px)", rotate: "90deg" }}
              size={34}
              color={colors.warmGray650}
            />
          </VStack>
        </Box>
      )}
    </VStack>
  );
}
